import React, { Component } from 'react';
import accounts from 'accounts/Accounts.js';
import {getNotes} from './getNotes.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ipfs from 'decentralized/Ipfs.js';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import ethereum from 'decentralized/ethereum.js';
import PulseLoader from 'react-spinners/PulseLoader'
import {SEQUENCE} from 'decentralized/messaging/message-types.js';

const PAGE_SIZE = 10;

class CommentsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commentText: '',
            commentSent: false,
            notes: [],
            start: 0,
            messageSent: undefined,
        };

        this.getNotes();
        this.watchForNotes();
    }

    async watchForNotes() {
        if (this.props.sequence.id === undefined) {
            return;
        }

        ethereum.messaging.watchForNewMessages(
            this.props.sequence.id,
            this.props.userId,
            (note) => this.onNewNote(note));
    }

    onNewNote(note) {
        if (note.messageHash === this.state.messageSent) {
            this.setState({messageSent: undefined});
        }
        this.setState({
            notes: [note, ... this.state.notes]
        });
    }

    async getNotes() {
        let notes = await getNotes(this.props.sequence.id);
        if (notes === undefined) {
            return;
        }
        this.setState({notes: notes});
    }

    async sendComment() {
        let referenceHash = this.props.sequence.id;
        let userId = this.props.userId;
        let messageContent = this.state.commentText;
        let messageType = SEQUENCE;

        let messageSent = await ethereum.messaging.sendMessage(
            userId,
            referenceHash,
            messageType,
            messageContent);

        this.setState({commentText: '', commentSent: true, messageSent: messageSent});
    }

    needsPagination() {
        return this.notes.length > PAGE_SIZE;
    }

    getPaginatedNotes() {
        if (this.notes.length > this.state.start + PAGE_SIZE) {
            return this.notes.slice(
                this.state.start, this.state.start + PAGE_SIZE);
        } else {
            return this.notes.slice(this.state.start);
        }
    }

    getPagination() {
        return (
            <div className="pagination">
            </div>
        );
    }

    render() {
        return (
            <div className="comments-container">
              <ConditionedComponent condition={accounts.isLoggedIn()}>
                <InputGroup className="tag-sound-input">
                  <Input
                    onChange={(event) => {
                        this.state.commentText = event.target.value;
                        this.setState(this.state);
                    }}
                    type="textarea"
                    value={this.state.commentText}
                    placeholder="Write a note" className="comment-input-box"/>
                  <InputGroupAddon addonType="append">
                    <Button size="sm" onClick={() => this.sendComment()} color="secondary">Send</Button>
                  </InputGroupAddon>
                </InputGroup>
              </ConditionedComponent>
              <PulseLoader
                sizeUnit={"px"}
                size={10}
                color={'#f92360'}
                loading={this.state.messageSent !== undefined}
                />
                {this.state.notes.map(
                (note, i) => <Note odd={i % 2 == 1} note={note}/>)}
                <div onClick={this.props.onHide} className="common-button hide-notes-button">
                  Hide Notes
                </div>
            </div>
        );
    }
}

class Note extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messageText: '',
            fromUser: props.note.fromUser,
            isFavorite: false,
            date: '',
        };

        this.getMessage();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.note !== nextProps.note) {
            this.getMessage(nextProps.note);
        }
        return true;
    }

    async getMessage(note=this.props.note) {
        let userId = note.fromUser ? note.fromUser :
            note.user;
        let userName = await ethereum.users.getUserName(userId);
        if (userName !== undefined) {
            this.setState({fromUser: userName});
        }

        let date = await ethereum.getBlockDate(note.blockNumber);
        this.setState({
            date: date === undefined ? '': date.toLocaleString(),
        });
        
        if (note.isPrevious) {
            this.setState({
                newSequence: note.newSequence,
                messageText: 'Made an edit (' + note.title + ')'});
            return;
        } else if (note.newSequence) {
            this.setState({
                newSequence: note.newSequence,
                messageText: 'Made an edit (' + note.title + ')'});

            return;
        } else if (note.isFavorite) {
            this.setState({
                isFavorite: true,
                messageText: 'Favorited'
            });

            return;
        }
        let message = await ipfs.getJson(note.messageHash, true);
        this.setState({messageText: message.content});

    }

    onClickText() {
        if (this.state.newSequence) {
            var win = window.open('/create/' + this.state.newSequence, '_blank');
            win.focus();
        }
    }

    onClickUser() {
        var win = window.open('/user/' + this.state.fromUser, '_blank');
        win.focus();
    }

    render() {
        let className = "sequence-note-container";
        if (this.props.odd) {
            className += ' odd';
        }
        return (
            <div className={className}>
              <div
                onClick={() => this.onClickUser()}
                className="sequence-note-from">{this.state.fromUser}:</div>
              <div onClick={() => this.onClickText()} className="sequence-note-text">
                <ConditionedComponent condition={!this.state.isFavorite}>
                  {this.state.messageText}
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.isFavorite}>
                  <div className="heart favorited"/>
                </ConditionedComponent>
              </div>
              <div className="note-date">{this.state.date}</div>
            </div>
        );
    }
}

export default CommentsComponent;
